<template>
  <section v-if="componentReady" class="container-wrapper service-request-page">
    <div class="container">
      <BaseButton
        type="secondary"
        class="service-request-page__prev"
        @click.native="$router.go(-1)"
      >
        {{ pageData.backButtonText }}
      </BaseButton>

      <h1>{{ pageData.title }}</h1>

      <CarInfo
        :image="{ src: pageData.car.image, alt: pageData.car.year}"
        :name="pageData.car.year"
        :modificationSupport="pageData.car.modification"
        reverse
      />

      <PeriodRange
        :key="`range-${pageData.range.selectedValue}`"
        :value="form.periodId"
        :title="pageData.range.title"
        :steps="pageData.range.steps"
        disabled
      />

      <div class="service-request-page__form">
        <!-- DISABLED FIELDS ROW -->
        <div class="service-request-page__form-filters">
          <BaseInput
            :key="`city-${pageData.filters.city.value}`"
            :value="pageData.filters.city.text"
            :label="pageData.filters.city.label"
            disabled
            class="service-request-page__form-input"
          />
          <BaseInput
            v-model="form.tel"
            :label="pageData.form.tel.label"
            :errorMsg="errorMsgs.tel"
            type="tel"
            mask="tel"
            class="service-request-page__form-input"
          />
        </div>
        <!-- DISABLED FIELDS ROW -->

        <div class="service-request-page__form-fields">
          <!-- COLUMN 1 -->
          <div class="service-request-page__form-col">
            <!-- <BaseSelect
              v-model="form.appeal"
              :items="pageData.form.appeal.items"
              :label="pageData.form.appeal.label"
              :placeholder="pageData.form.appeal.placeholder"
              :errorMsg="errorMsgs.appeal"
              class="service-request-page__form-input"
            /> -->
            <BaseInput
              v-model="form.firstName"
              :label="pageData.form.firstName.label"
              :errorMsg="errorMsgs.firstName"
              class="service-request-page__form-input"
            />
            <BaseInput
              v-model="form.lastName"
              :label="pageData.form.lastName.label"
              :errorMsg="errorMsgs.lastName"
              class="service-request-page__form-input"
            />
            <BaseInput
              v-model="form.middleName"
              :label="pageData.form.middleName.label"
              :errorMsg="errorMsgs.middleName"
              class="service-request-page__form-input"
            />
            <BaseInput
              :key="`dealer-${pageData.filters.dealer.value}`"
              :value="pageData.filters.dealer.text"
              :label="pageData.filters.dealer.label"
              disabled
              class="service-request-page__form-input"
            />
            <BaseInput
              v-if="pageData.form.comment"
              v-model="form.comment"
              :label="pageData.form.comment.label"
              :errorMsg="errorMsgs.comment"
              class="service-request-page__form-input"
            />
          </div>
          <!-- COLUMN 1 -->

          <!-- COLUMN 2 -->
          <div class="service-request-page__form-col">
            <BaseInput
              v-model="form.email"
              :label="pageData.form.email.label"
              :errorMsg="errorMsgs.email"
              type="email"
              class="service-request-page__form-input"
            />
            <BaseSelect
              v-model="form.connectType"
              :items="pageData.form.connectType.items"
              :label="pageData.form.connectType.label"
              :placeholder="pageData.form.connectType.placeholder"
              :errorMsg="errorMsgs.connectType"
              class="service-request-page__form-input"
            />
            <BaseInput
              v-model="form.carNumber"
              :label="pageData.form.carNumber.label"
              :errorMsg="errorMsgs.carNumber"
              class="service-request-page__form-input"
            />
            <BaseDatePicker
              v-if="pageData.form.dateTime.options.schedule"
              :label="pageData.form.dateTime.label"
              :buttonsText="pageData.form.dateTime.buttonsText"
              :options="datepickerOptions"
              :errorMsg="errorMsgs.dateTime"
              class="service-request-page__form-input"
              @input="form.dateTime = $event"
            />
          </div>
          <!-- COLUMN 2 -->
        </div>
      </div>

      <TablePrice
        :rows="pageData.priceTable.rows"
        :warning="pageData.priceTable.warning"
        class="service-request-page__table"
      />

      <div class="service-request-page__policy">
        <BaseCheckbox
          v-model="form.policy"
          :errorMsg="errorMsgs.policy"
        >
          <router-link
            to="/policy"
            class="simple-link"
          >
            {{ pageData.policy }}
          </router-link>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__marketing">
        <BaseCheckbox
          v-model="form.marketing_agree"
          :errorMsg="errorMsgs.marketing_agree"
        >
          <router-link
            to="/marketing"
            class="simple-link"
          >
            {{ pageData.form.marketing_agree.label }}
          </router-link>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__submit-button-container">
        <BaseButton
          :disabled="!form.policy"
          @click="submitForm"
        >
          {{ pageData.submitButtonText }}
        </BaseButton>
      </div>
    </div>
  </section>
</template>

<script>
  // Step 5

  import { mapGetters, mapActions } from 'vuex'
  import { get } from 'lodash'
  import CarInfo from '@/components/CarInfo'
  import PeriodRange from '@/components/PeriodRange'
  import TablePrice from '@/components/TablePrice'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'ServiceRequestPage',

    components: {
      CarInfo,
      PeriodRange,
      TablePrice
    },

    data () {
      return {
        pageData: {},
        form: {
          vin: '',
          open_campaigns: '',
          price: '',
          periodId: '',
          dealerId: '',
          appeal: '',
          connectType: '',
          firstName: '',
          lastName: '',
          middleName: '',
          tel: '',
          email: '',
          carNumber: '',
          dateTime: '',
          comment: '',
          policy: false,
          marketing_agree: false
        },
        componentReady: false,
        errorMsgs: {}
      }
    },

    computed: {
      ...mapGetters([
        'getModel',
        'getYear',
        'getModification',
        'getPeriod',
        'getCity',
        'getAliasParamCity',
        'getDealer',
        'getAliasParamDealer',
        'getOilId'
      ]),
      backButton () {
        const text = this.pageData.backButtonText
        const route = {
          name: 'tech-map',
          params: {
            model: this.getModel,
            year: this.getYear,
            modification: this.getModification
          },
          query: {
            period: this.getPeriod,
            city: this.getCity || this.getAliasParamCity,
            dealer: this.getDealer || this.getAliasParamDealer
          }
        }

        return { text, route }
      },
      datepickerOptions () {
        return {
          ...this.pageData.form.dateTime.options,
          requestServiceIn: this.pageData.filters.dealer.requestServiceIn
        }
      }
    },

    watch: {
      $route (to, from) {
        if (from.name === 'tech-map' && to.name === 'service-request') {
          this.pushDataToDataLayer({
            events: {
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'contact-details'
              }
            },
            pages: {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language: this.$store.state.currentLang
              }
            },
            forms: {
              form: {
                name: 'lead-book-service',
                step: 'contact-details',
                conversion: '0'
              }
            },
            products: {
              product: [{
                category: 'cars',
                subCategory: 'new-cars',
                productInfo: {
                  productId: this.stateModelId,
                  productName: this.stateModelName,
                  tmeModelId: this.stateModelId,
                  modelName: this.stateModelName
                }
              }]
            },
            dealers: {
              dealer: {
                name: this.stateDealerName,
                dealerId: this.stateDealerId,
                city: this.stateDealerCity,
                zipcode: this.stateDealerZipCode
              }
            }
          }, true)
        }
      }
    },

    activated () {
      this.initPage()
    },

    beforeDestroy () {
      if (this.getOilId) this.$store.commit('SET_OIL_ID', '')
    },

    mounted () {
      this.stateModelId = get(this, '$store.state.model.modelId', '') || get(this, 'pageData.car.modificationId', '')
      this.stateModelName = get(this, '$store.state.model.modelText', '') || get(this, 'pageData.car.modificationName', '')
      this.stateDealerName = get(this, '$store.state.dealer.dealerName', '')
      this.stateDealerId = get(this, '$store.state.dealer.dealerId', '')
      this.stateDealerCity = get(this, '$store.state.dealer.dealerCity', '')
      this.stateDealerZipCode = get(this, '$store.state.dealer.dealerZipCode', '')

      this.pushDataToDataLayer({
        events: {
          event: {
            name: 'formevent',
            componentName: 'book-service',
            componentGroup: 'forms',
            action: 'form-step',
            label: 'contact-details'
          }
        },
        pages: {
          page: {
            category: 'tools',
            subCategory: 'form',
            sectionlv1: 'forms',
            sectionlv2: 'book-service',
            language: this.$store.state.currentLang
          }
        },
        forms: {
          form: {
            name: 'lead-book-service',
            step: 'contact-details',
            conversion: '0'
          }
        },
        products: {
          product: [{
            category: 'cars',
            subCategory: 'new-cars',
            productInfo: {
              productId: this.stateModelId,
              productName: this.stateModelName,
              tmeModelId: this.stateModelId,
              modelName: this.stateModelName
            }
          }]
        },
        dealers: {
          dealer: {
            name: this.stateDealerName,
            dealerId: this.stateDealerId,
            city: this.stateDealerCity,
            zipcode: this.stateDealerZipCode
          }
        }
      }, true)
    },

    methods: {
      ...mapActions(['fetchServiceRequestPageData', 'submitServiceRequest']),
      pushDataToDataLayer (params = {}, pushDataLayer = false) {
        window.dataLayer = window.dataLayer || []

        this.stateModelId = get(this, '$store.state.model.modelId', '') || get(this, 'pageData.car.modificationId', '')
        this.stateModelName = get(this, '$store.state.model.modelText', '') || get(this, 'pageData.car.modificationName', '')
        this.stateDealerName = get(this, '$store.state.dealer.dealerName', '')
        this.stateDealerId = get(this, '$store.state.dealer.dealerId', '')
        this.stateDealerCity = get(this, '$store.state.dealer.dealerCity', '')
        this.stateDealerZipCode = get(this, '$store.state.dealer.dealerZipCode', '')

        window.tngaDataLayer = { ...params.events, ...params.pages, ...params.forms, ...params.products, ...params.dealers }
        if (pushDataLayer) window.dataLayer.push({ 'event': 'formevent' })
      },
      async initPage () {
        const data = await this.fetchServiceRequestPageData({
          model: this.getModel,
          year: this.getYear,
          modification: this.getModification,
          period: this.getPeriod,
          city: this.getCity,
          dealer: this.getDealer,
          // oil: this.$route.params.oil,
          oil: this.getOilId,
          workpackages: this.$route.query.workpackages
        })

        this.pageData = { ...data }
        this.initForm()
        this.componentReady = true
      },
      initForm () {
        if (this.getOilId) this.form.oil = this.getOilId

        this.form.workpackages = this.$route.query.workpackages

        this.form.vin = this.$store.state.vinSearchData.vin
        this.form.open_campaigns = this.$store.state.vinSearchData.open_campaigns
        this.form.periodId = this.pageData.range.selectedValue
        this.form.dealerId = this.pageData.filters.dealer.value
        this.form.price = parseFloat(this.pageData.priceTable.rows[this.pageData.priceTable.rows.length - 3].value)
        const phoneItem = this.pageData.form.connectType.items.find(item => item.value === 'phone')
        if (phoneItem) {
          this.form.connectType = phoneItem.value
        }
      },
      async submitForm () {
        this.errorMsgs = {}

        const payload = {
          ...this.form,
          dateTime: this.form.dateTime / 1000 // timestamp in seconds, not miliseconds
        }

        try {
          const errors = await this.submitServiceRequest({
            submitUrl: this.pageData.formSubmitUrl,
            form: payload
          })

          if (errors.length === 0) {
            if (this.getOilId) this.$store.commit('SET_OIL_ID', '')
            this.pushDataToDataLayer({
              events: {
                event: {
                  name: 'formevent',
                  componentName: 'book-service',
                  componentGroup: 'forms',
                  action: 'form-step',
                  label: 'form-submit'
                }
              },
              pages: {
                page: {
                  category: 'tools',
                  subCategory: 'form',
                  sectionlv1: 'forms',
                  sectionlv2: 'book-service',
                  language: this.$store.state.currentLang
                }
              },
              forms: {
                form: {
                  name: 'lead-book-service',
                  step: 'form-submit',
                  conversion: '1'
                }
              },
              products: {
                product: [{
                  category: 'cars',
                  subCategory: 'new-cars',
                  productInfo: {
                    productId: this.stateModelId,
                    productName: this.stateModelName,
                    tmeModelId: this.stateModelId,
                    modelName: this.stateModelName
                  }
                }]
              },
              dealers: {
                dealer: {
                  name: this.stateDealerName,
                  dealerId: this.stateDealerId,
                  city: this.stateDealerCity,
                  zipcode: this.stateDealerZipCode
                }
              }
            }, true)
            let query = {}

            if (this.$store.state.currentLang !== DEFAULT_LANG) {
              query = { lang: this.$store.state.currentLang }
            }

            this.$router.push({ name: 'thank-you', query: query })
          } else {
            Object.keys(errors)
              .forEach(errKey => {
                this.$set(this.errorMsgs, errKey, errors[errKey][0])
              })

            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        } catch (e) {
          let query = {}

          if (this.$store.state.currentLang !== DEFAULT_LANG) {
            query = { lang: this.$store.state.currentLang }
          }
          this.$router.push({ name: 'not-found', query })
          console.error('FAILED: submitServiceRequest')
        }
      }
    }
  }
</script>

<style lang="scss">
.service-request-page {
  padding-bottom: 70px;

  @include mobile {
    padding-bottom: 40px;
    overflow: hidden;
  }

  &__prev {
    min-width: 81px;
    margin-bottom: 80px;

    @include mobile {
      margin-bottom: 40px;
    }
  }

  &__form {
    padding-bottom: 35px;
    margin-top: 80px;

    @include tablet {
      margin-top: 60px;
    }

    @include mobile {
      padding-bottom: 20px;
    }

    &-filters,
    &-fields {
      display: flex;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
      }
    }

    &-col {
      width: 100%;

      &:last-child {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
      }
    }

    &-input {
      width: 100%;
      min-width: 335px;
      max-width: 499px;
      padding-bottom: 25px;

      @include tablet {
        min-width: 320px;
        max-width: 320px;
      }

      @include mobile {
        min-width: 100%;
        max-width: 100%;
        padding-bottom: 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .datepicker__field,
      .select__field,
      input {
        height: 50px;
      }

      .select__dropdown {
        top: 81px;
      }
    }
  }

  &__table {
    padding: 60px 60px 40px;

    @include tablet {
      padding: 60px 40px 40px;
    }

    @include mobile {
      padding: 30px 25px 18px;

      h4 {
        font-size: 18px;
        line-height: 26px;
        text-align: left;
        letter-spacing: 0.08;
      }
    }
  }

  &__marketing {
    display: flex;
    justify-content: flex-start;
    padding: 0 60px 60px;
    background: $c-gray-light;

    @include tablet {
      padding: 0 40px 6 0;
    }

    @include mobile {
      padding: 0 25px 30px;
    }

    .simple-link {
      font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
      text-decoration: none;

      @include hover {
        color: $c-black;
      }
    }
  }

  &__policy {
    display: flex;
    justify-content: flex-start;
    padding: 0 60px 30px;
    background: $c-gray-light;

    @include tablet {
      padding: 0 40px 6 0;
    }

    @include mobile {
      padding: 0 25px 20px;
    }

    .simple-link {
      font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
      text-decoration: none;

      @include hover {
        color: $c-black;
      }
    }
  }

  &__submit-button-container {
    display: flex;
    justify-content: center;
    padding-bottom: 60px;
    background: $c-gray-light;

    @include mobile {
      padding-bottom: 40px;
    }
  }
}
</style>
